import React, { useState } from "react";
import * as FontAwesome from "react-icons/fa";
import type { IconType } from "react-icons";
import { useFormInput } from "../../custom-hooks/useFormInput";
import IconList from "./IconList";
import "./IconPicker.scss";
import LoadingGlass from "../loadSpinner/LoadingGlass";
import { icons } from "./IconUtils";
import { withDefaults } from "../../utils/withDefaults";

let typingTimer: number | undefined;

export interface IconPickerProps {
  /** Name of a react-icons Font Awesome component, e.g. "FaReddit". */
  chosenIcon?: string;
  setChosenIcon?: (icon: string) => void;
}

export default function IconPicker(incomingProps: IconPickerProps) {
  const props = withDefaults(incomingProps, iconPickerDefaultProps);

  const [isPickerVisible, setIsPickerVisible] = useState(false);
  const [isUserTyping, setIsUserTyping] = useState(false);
  const filteredText = useFormInput("");
  const [myIcons, setMyIcons] = useState(icons);

  const allIcons: Record<string, IconType> = FontAwesome;
  // Fall back if a saved icon no longer exists in react-icons v5.
  const IconComponent: IconType =
    allIcons[props.chosenIcon] ?? allIcons.FaBeer;

  const onInputKeyUp = () => {
    clearTimeout(typingTimer);
    typingTimer = window.setTimeout(onDoneTyping, 500);
  };

  const onInputKeyDown = () => {
    clearTimeout(typingTimer);
  };

  const onDoneTyping = () => {
    setMyIcons(
      icons.filter(icon =>
        icon.toLowerCase().includes(filteredText.value.toLowerCase())
      )
    );
    setIsUserTyping(false);
  };

  const handleChangingInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    filteredText.onChange(event);
    if (!isUserTyping) {
      setIsUserTyping(true);
    }
  };

  return (
    <div className="icon-picker-container" style={{ position: "relative" }}>
      <div
        className="icon-container"
        onClick={() => setIsPickerVisible(!isPickerVisible)}
        aria-label="Icon Picker Selected Icon"
      >
        <IconComponent className="icon" aria-label={props.chosenIcon} />
      </div>
      {isPickerVisible ? (
        <div className="all-icons">
          <input
            value={filteredText.value}
            onChange={handleChangingInput}
            className="icon-picker-input"
            onKeyDown={onInputKeyDown}
            onKeyUp={onInputKeyUp}
            placeholder="Search icons..."
          />
          <div className="icon-list">
            {isUserTyping ? (
              <LoadingGlass style={{ height: "calc(100% - 31px)" }} />
            ) : null}
            <IconList
              icons={myIcons}
              setChosenIcon={props.setChosenIcon}
              setIsPickerVisible={setIsPickerVisible}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}

const iconPickerDefaultProps = {
  chosenIcon: "FaBeer",
  setChosenIcon: () => {}
};
